<template>
    <group-report-template  v-model:for-group="forGroup"
                            v-model:interval="$data._interval"
                            v-model:reload-data="$data._reloadTable"
                            report-name="alarm-resolution-report"
                            v-model:running-errors="$data._errorSending"
                            v-model:ran-report="$data._reportSuccessfullySent"
                            v-model:running-report="$data._runningReport"
                            v-model:current-report-template-id="$data._reportTemplateId"
                            v-model:display-section="displaySection"
                            v-model:settings="$data._settings"
                            :default-settings="defaultSettings"
                            :can-edit="permissions.can('manage_alarm_resolution_report')"
                            @useStandardReporting="setUseStandardReporting"
    >
        <template   #create-settings>
            <alarm-resolution-report-settings
                v-model:interval="$data._interval"
                v-model:receive-weekday="receiveWeekday"
                v-model:settings="$data._settings"
                :is-savable="true"
            ></alarm-resolution-report-settings>
        </template>

        <template   #edit-settings>
            <alarm-resolution-report-settings
                v-model:interval="$data._interval"
                v-model:receive-weekday="receiveWeekday"
                v-model:settings="$data._settings"
                :is-savable="displaySection === 'show-template' || useStandardReporting"
            ></alarm-resolution-report-settings>
        </template>
        <template   #run-options>
            Select Start & End of interval
            <!-- Select Start -->
            <div class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
                <label for="start">Start of Interval</label>
                <date-time-picker   id="start"
                                    v-model="$data._startOfInterval"
                                    :format="format"
                                    :max-date="$data._endOfInterval"
                                    :min-date="minDate"
                                    :view-mode="viewMode"
                                    :timezone="timezone"
                ></date-time-picker>
            </div>

            <!-- Select end -->
            <div class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
                <label for="end">End of Interval</label>
                <date-time-picker   id="end"
                                    v-model="$data._endOfInterval"
                                    :format="format"
                                    :max-date="maxDate"
                                    :min-date="$data._startOfInterval"
                                    :view-mode="viewMode"
                                    :timezone="timezone"
                ></date-time-picker>
            </div>

            <div class="flex justify-center">
                <button v-if="isRunning"
                        class="col-span-2 w-full lg:w-2/3 my-4 relative inline-flex items-center justify-center
                        px-4 py-2 border border-transparent text-sm bg-blue-600 text-white font-medium py-2 px-4
                        rounded opacity-50 cursor-not-allowed">
                    <span class="lnr icon-loading animate-spin mr-3"></span>
                    Running Report, Please Wait
                </button>
                <button v-else
                        class="col-span-2 w-full lg:w-2/3 my-4 relative inline-flex items-center justify-center px-4 py-2 border
                        border-transparent text-sm leading-5 font-medium rounded-md text-white bg-blue-600
                        hover:bg-blue-500 focus:outline-none focus:ring-blue-200 focus:border-blue-700
                        active:bg-blue-700"
                        @click="runReport($data._reportTemplateId)">
                    Run Report
                </button>
            </div>
        </template>
    </group-report-template>

</template>

<script>
import axios from "axios"
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import {SonicuCoreMixin} from "../../mixins/SonicuCoreMixin";
import {ajaxTableMixin} from "../../mixins/ajaxTableMixin";
import ReportHomeModal from "./ReportHomeModal";
import ButtonBlueSecondary from "../elements/buttons/ButtonBlueSecondary";
import BaseReport from "../Reports/BaseReport";
import MeterIntervalSelection from "./MeterIntervalSelection";
import DetailedAlarmReportSettings from "./DetailedAlarmReportSettings";
import AjaxTable from "../elements/AjaxTable";
import Select2 from "../elements/select2";
import SlideOverPanel from "../elements/SlideOverPanel";
import ButtonRedSecondary from "../elements/buttons/ButtonRedSecondary";
import ButtonGreenPrimary from "../elements/buttons/ButtonGreenPrimary";
import AlarmResolutionReportSettings from "./AlarmResolutionReportSettings";
import DateTimePicker from "../Reports/DateTimePicker";
import GroupReportTemplate from "./GroupReportTemplate";

const SHOW_MANUAL = 'show-manual'
const SHOW_TEMPLATE = 'show-template'

export default {
    name: "GroupAlarmResolutionReport",
    mixins: [SonicuCoreMixin, ajaxTableMixin],
    components: {
        GroupReportTemplate,
        DateTimePicker,
        AlarmResolutionReportSettings,
        ButtonGreenPrimary,
        ButtonRedSecondary,
        SlideOverPanel,
        AjaxTable,
        DetailedAlarmReportSettings, MeterIntervalSelection, BaseReport, ReportHomeModal, ButtonBlueSecondary, Select2,
        Menu, MenuButton, MenuItem, MenuItems,
        // ChevronDownIcon, PlayIcon, EyeIcon, PencilSquareIcon, PlusCircleIcon
    },
    props: {
        receiveWeekday: {
            type: Number,
            default: 1,
        },
        interval: {
            type: String,
            default: 'monthly',
        },
        meters: {
            type: Object,
            default() {
                return {}
            },
        },
        minDate: {
            type: [Date, String],
            default: new Date(),
        },
        maxDate: {
            type: [Date, String],
            default: new Date(),
        },
        defaultSettings: {
            type: Object,
            default() {
                return {}
            }
        },
        timezone: {
            type: String,
            default: 'America/New_York',
        },
    },
    data() {
        return {
            displaySection: null,

            // Manual Run Stuff
            // Interval Things for manual run
            _startOfInterval: new Date(),
            _endOfInterval: new Date(),
            format: _.indexOf(['monthly', 'semi-monthly'], this.intervalInput) > -1 ? 'MMMM YYYY' : 'MMMM DD, YYYY',
            viewMode: _.indexOf(['monthly', 'semi-monthly'], this.intervalInput) > -1  ? 'months' : 'days',
            isRunning: false,

            _interval: this.interval,
            _selectedMeters: [],
            _templateName: '',
            _groupId: null,
            _runningReport: false,
            _reportSuccessfullySent: false,
            _errorSending: [],
            _reportTemplateId: null,

            // Template Run Stuff
            headers: [
                {
                    name: 'Report Template',
                    key: 'template_name',
                    sortBy: 'reportTemplate',
                },
                {
                    name: 'Send Interval',
                    key: 'report_duration_type',
                    sortBy: 'sendInterval',
                },
                {
                    name: '',
                    key: 'created_at',
                },
            ],
            data: [],

            _reloadTable: false,
            _settings: this.defaultSettings,

            currentReportTemplateIndex: null,
            showIntervalSelectionPanel: false,
            showCreateTemplatePanel: false,
            showEditTemplatePanel: false,
            forGroup: false,
            useStandardReporting: false,
        }
    },
    created() {
        this.$data._startOfInterval.setDate(this.$data._startOfInterval.getDate() - 1)
    },
    mounted() {

    },
    methods: {
        runReport(reportTemplateId = null) {
            let params = {}
            if (reportTemplateId !== null) {
                params['reportTemplateId'] = reportTemplateId
                params['forGroup'] = this.forGroup
            }

            params['start'] = this.$data._startOfInterval
            params['end'] = this.$data._endOfInterval

            // return
            this.$data._runningReport = true
            axios.post(this.company.buildCompanyRoute('group-reports/alarm-resolution-report'), params)
                .then(response => {
                    let data = response.data
                    this.$data._reportSuccessfullySent = true
                    console.log(`Report Queued successfully, data is`)
                    console.log(data)
                })
                .catch(response => {
                    let data = response.data
                    this.$data._errorSending = data
                    console.log(`Report Queued Failed, data is`)
                    console.log(data)
                })
                .finally(() => {
                    console.log(`Report finalizing`)
                    this.$data._runningReport = false
                })
        },
        resetTemplateRun() {
            this.currentReportTemplateIndex = null
            this.showIntervalSelectionPanel = false
            this.showEditTemplatePanel = false
            this.showCreateTemplatePanel = false
            this.forGroup = false
        },
        setUseStandardReporting(event) {
            this.useStandardReporting = event
        }
    },
    computed: {},
    watch: {
        showIntervalSelectionPanel(val, old) {
            if (val !== old && val === false) {
                this.resetTemplateRun()
            }
        },
        showEditTemplatePanel(val, old) {
            if (val !== old && val === false) {
                this.resetTemplateRun()
            }
        },
        _settings(val, old) {
            if (val !== old) {
                this.$data._settings = val
            }
        },
        defaultSettings(val, old) {
            if (val !== old) {
                this.$data._settings = val
            }
        },
    },
}
</script>

<style scoped>

</style>